import React, { useState, useEffect } from "react";
import { getEcoCrosspromo } from "../../api/services";
import { Card, Loading } from "./UI";
import { fmtNum } from "../../utils/format";
import styles from "./EcoCrosspromo.module.css";

// Панель замера гипотезы ICE-8: переходы из Рублокса в соседние продукты.
// Источник — eco_click_* события в metrika_events (проставлены во фронтах
// Рублокса хелпером trackEcoClick). Показываем клики/уникальных, места
// размещения и динамику по неделям.

const PLACE_LABELS = {
  landing_block: "Блок на лендинге",
  feed_promo: "Промо в ленте",
  more_menu: "Меню «Ещё»",
  more_menu_diamonds: "Меню — алмазы",
  more_menu_school: "Меню — школа",
  footer: "Футер",
  sidebar: "Сайдбар кабинета",
  studio_header: "Шапка студии",
  player_help: "Помощь в игре",
  comments_cta: "Под комментариями",
};

const COLORS = { minecraftia: "#3fb950", maska: "#e8445a" };

export default function EcoCrosspromo() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getEcoCrosspromo(90).then((d) => {
      if (active) { setData(d); setLoading(false); }
    }).catch(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  if (loading) return <Card title="Переходы из Рублокса в экосистему"><Loading /></Card>;
  const products = data?.products || [];
  const totalClicks = products.reduce((s, p) => s + (p.clicks || 0), 0);

  return (
    <Card title="Переходы из Рублокса в экосистему">
      <div className={styles.hint}>
        Гипотеза: рассказали про соседние продукты в Рублоксе — дети переходят.
        Клики по ссылкам на Майнкрафтию и Маську из всех экранов Рублокса
        (лендинг, кабинет, студия, плеер). За последние 90 дней.
      </div>

      {totalClicks === 0 ? (
        <div className={styles.empty}>
          Переходов пока нет. Данные появятся после деплоя фронтов Рублокса
          с блоками экосистемы и первых кликов пользователей.
        </div>
      ) : (
        <>
          <div className={styles.kpis}>
            {products.map((p) => (
              <div key={p.product} className={styles.kpi}>
                <span className={styles.dot} style={{ background: COLORS[p.product] }} />
                <div>
                  <div className={styles.kpiTitle}>{p.title}</div>
                  <div className={styles.kpiVal}>{fmtNum(p.clicks)} <span>кликов</span></div>
                  <div className={styles.kpiSub}>
                    {fmtNum(p.visitors)} уник. · {fmtNum(p.users)} с аккаунтом
                  </div>
                </div>
              </div>
            ))}
          </div>

          {data.places?.length > 0 && (
            <>
              <div className={styles.blockTitle}>Где кликают</div>
              <div className={styles.places}>
                {data.places.map((pl, i) => (
                  <div key={i} className={styles.placeRow}>
                    <span className={styles.placeDot} style={{ background: COLORS[pl.product] }} />
                    <span className={styles.placeName}>
                      {PLACE_LABELS[pl.place] || pl.place}
                    </span>
                    <span className={styles.placeProd}>
                      {pl.product === "maska" ? "Маська" : "Майнкрафтия"}
                    </span>
                    <span className={styles.placeClicks}>{fmtNum(pl.clicks)}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </Card>
  );
}
